module.exports = __webpack_public_path__ + "img/tvShowEnabled.47c4a0.svg";